import { SurveyTemplateParser } from '../../../../utilities/surveys/SurveyTemplateParser';
import { SurveyV2, UserDto } from '@act/shared/data-transfer-objects';
import { FlexSection } from '../../../../containers/Pillbox/components';
import * as numberToWords from 'number-to-words';
import { GoalCardActions } from '../actions/GoalCardActions';
import { GoalCardActionItems } from '../../shared-types';
import { AssignedSurveySummaryDateLine } from '../dateLines/AssignedSurveySummaryDateLine';

interface AssignedSurveyGoalSummaryProps {
  assignedSurvey: SurveyV2.AssignedSurveyDto;
  member: UserDto;
  actions?: GoalCardActionItems[];
  summary?: JSX.Element;
}

export const AssignedSurveyGoalSummary = ({
  assignedSurvey,
  member,
  actions,
  summary,
}: AssignedSurveyGoalSummaryProps) => {
  const lastPhase = assignedSurvey.phases[assignedSurvey.phases.length - 1];
  const currentPhase = assignedSurvey.phases
    .filter(phase => phase.checkpoint && phase.completedAt)
    .sort((a, b) => b.completedAt - a.completedAt)[0];

  const completionCheckpoint = currentPhase?.checkpoint;
  const surveyIsComplete = completionCheckpoint?.isCompletionCheckpoint;

  let newNeedsCreatedText;
  if (assignedSurvey?.needIds?.length > 0) {
    newNeedsCreatedText = (
      <p>
        <span className="sentence-case">
          {`${numberToWords.toWords(assignedSurvey.needIds.length)} `}
        </span>
        new need
        {assignedSurvey.needIds.length > 1 ? 's' : ''} created:
      </p>
    );
  }

  const hasCustomSummary = surveyIsComplete && lastPhase?.summary;
  const summaryBody = hasCustomSummary ? (
    <>
      <p>{lastPhase.summary}</p>
      {newNeedsCreatedText}
    </>
  ) : (
    <div>
      <SurveyTemplateParser
        template={
          completionCheckpoint?.summary || assignedSurvey.survey.summary
        }
        member={member}
        assignedSurvey={assignedSurvey}
      />
    </div>
  );
  return (
    <FlexSection direction="column" gap={16}>
      <AssignedSurveySummaryDateLine assignedSurvey={assignedSurvey} />
      {summaryBody}
      {summary}
      <GoalCardActions actions={actions} />
    </FlexSection>
  );
};
